module.exports = __webpack_public_path__ + "static/media/chips-and-salsa-cabreras.7467c0e6.jpg";